exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setting-header[data-v-4f05ecaa]{background-color:#fbfbfb}.setting-body[data-v-4f05ecaa]{background-color:#fdfdfd}.gravatar-pic[data-v-4f05ecaa]{border-radius:50%;width:100px;display:initial;margin-bottom:6px}.call-details-box[data-v-4f05ecaa]{font-weight:700;font-size:14px;padding-top:10px}", ""]);

// exports
